// extracted by mini-css-extract-plugin
module.exports = {"MainConatiner":"Dashboard_MainConatiner__1Nt37","ChildCard":"Dashboard_ChildCard__1o4Fs"};